// extracted by mini-css-extract-plugin
export default {"container":"category-item_container__JoA2J","link":"category-item_link__VJAGs","text":"category-item_text__WfmKc"};